<template>
  <div>
    <div class="back" @click="goBack">&lt; 返 回</div>
    <div class="common-style addBook">
      <a-form id="add" :form="form" ref="formbook">
        <a-form-item v-bind="formItemLayout" label="学段">
          <a-select v-model="modelForm.stageName">
            <a-select-option
              v-for="(item, index) in stagesList"
              :key="index"
              @click="changeStages(index)"
            >
              <span v-if="index != 0">{{ item }}</span>
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item v-bind="formItemLayout" label="学科">
          <a-select @change="changeSubjects($event)" v-model="modelForm.subjectName">
            <a-select-option v-for="(item, index) in subjectsList" :key="index">
              <span v-if="index != 0">{{ item }}</span>
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item v-bind="formItemLayout" label="教材版本（选填）">
          <a-select
            @change="changeVersions($event)"
            v-model="modelForm.versionName"
            :allowClear="true"
          >
            <a-select-option v-for="(item, index) in versionsList" :key="index">{{ item }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item v-bind="formItemLayout" label="年级（选填）">
          <a-select @change="changeGrades($event)" v-model="modelForm.gradeName" :allowClear="true">
            <a-select-option v-for="(item, index) in gradesList" :key="index">
              {{
              item
              }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item v-bind="formItemLayout" label="年级上下册（选填）">
          <a-select
            v-model="formDate.volumeid"
            @change="changeVolume($event)"
            :defaultActiveFirstOption="false"
            :allowClear="true"
          >
            <a-select-option :value="0">上册</a-select-option>
            <a-select-option :value="1">下册</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item v-bind="formItemLayout" label="组织机构（选填）" v-if="this.$store.getters.orgid == 0">
          <a-select v-model="modelForm.orgName" :allowClear="true" @change="changeOrg">
            <a-select-option v-for="item in orgList" :key="item.id" :value="item.id">{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item
          v-bind="formItemLayout"
          label="共享组织学校（选填）"
          v-if="this.$store.getters.orgid == 0"
        >
          <a-select
            mode="multiple"
            placeholder="请选择共享组织学校"
            v-model="formDate.sharesorgids"
            @change="changeSharesorg"
          >
            <a-select-option
              v-for="item in orgList"
              :key="item.id.toString()"
              :value="item.id"
            >{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item v-bind="formItemLayout" label="教辅名称">
          <a-input v-model="formDate.name" />
        </a-form-item>
        <a-form-item v-bind="formItemLayout" label="封面图片">
          <a-upload
            name="avatar"
            style="width:105px;"
            listType="picture-card"
            class="avatar-uploader"
            accept=".png, .jpg, .jpeg"
            :action="upload.root + 'v1/learnonly/jf/image'"
            :headers="upload.headers"
            :data="uploadFormData"
            :showUploadList="false"
            @change="handleChange"
          >
            <img
              v-if="imageUrl || coverFullUrl"
              :src="imageUrl || coverFullUrl"
              alt="avatar"
              style="width:110px;height:100px;"
            />
            <div v-else>
              <a-icon :type="loading ? 'loading' : 'plus'" />
              <div class="ant-upload-text">选择图片</div>
            </div>
          </a-upload>
          <p style="color:#999;">建议尺寸：180*160(px)</p>
        </a-form-item>

        <a-form-item v-bind="formItemLayout" label="教辅描述">
          <a-textarea :autosize="{ minRows: 2, maxRows: 6 }" v-model="formDate.describes" />
        </a-form-item>
        <!-- <el-select v-model="resInfo.collaborators" @change="collaboratorsChange" multiple placeholder="请选择">
                    <el-option v-for="item in collaborators" :key="item.id" :label="item.fullname" :value="item.id" size="small">
                    </el-option>
        </el-select>-->
        <a-form-item v-bind="formItemLayout" label="协作人（选填）">
          <a-select
            mode="multiple"
            placeholder="请选择姓名"
            v-model="formDate.collaborators"
            @change="handleSearch"
          >
            <a-select-option
              v-for="item in collaboratorsList"
              :key="item.id.toString()"
              :value="item.id"
            >{{ item.fullname }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item v-bind="formItemLayout" label="教辅状态">
          <a-radio-group @change="getTeachState($event)" :value="formDate.state">
            <a-radio :value="0">撰写中</a-radio>
            <a-radio :value="1">已完结</a-radio>
          </a-radio-group>
        </a-form-item>

        <a-form-item v-bind="formItemLayout" label="目标公开">
          <a-radio-group @change="getPublicState($event)" :value="formDate.publicState">
            <a-radio v-if="$store.getters.roles.includes('admin')" :value="0">公开</a-radio>
            <a-radio :value="1">校本</a-radio>
            <a-radio :value="2">个人</a-radio>
          </a-radio-group>
        </a-form-item>

        <a-form-item :wrapper-col="{ span: 12, offset: 6 }">
          <a-button
            type="primary"
            @click="createList('formbook')"
            :style="{ margin: '0 50px 0 0' }"
            v-if="!svaeType"
          >下一步（创建目录）</a-button>
          <a-button
            type="primary"
            @click="getModifyList('formbook')"
            :style="{ margin: '0 50px 0 0' }"
            v-if="svaeType"
          >修改教辅</a-button>
          <a-button type="danger" @click="deleteBook()" v-if="svaeType">删除教辅</a-button>
        </a-form-item>
      </a-form>
    </div>
  </div>
</template>

<script>
import { setTimeout } from "timers"
function getBase64 (img, callback) {
  const reader = new FileReader()
  reader.addEventListener("load", () => callback(reader.result))
  reader.readAsDataURL(img)
}
export default {
  data () {
    return {
      modifyList: [],
      svaeType: false,
      upload: {
        root: process.env.VUE_APP_BASE_API,
        headers: { authorization: this.$store.getters.token },
      },
      uploadFormData: {
        cover: "",
      },
      formItemLayout: {
        labelCol: { span: 7 },
        wrapperCol: { span: 12 },
      },
      stagesList: [], //学段下拉数组
      subjectsList: [], //学科下拉数组
      versionsList: [], //版本下拉数组
      gradesList: [], //年级下拉数组
      orgList: [], //组织机构
      collaboratorsList: [], //协作人
      searchVal: "",
      writeName: "",
      loading: false,
      imageUrl: "",
      coverFullUrl: "",
      modelForm: {
        stageName: "",
        subjectName: "",
        versionName: "",
        gradeName: "",
        orgName: "",
      },
      formDate: {},
    }
  },
  beforeCreate () {
    this.form = this.$form.createForm(this)
  },
  methods: {
    getModifyData () {
      // 修改教辅
      if (this.$route.query.type == true) {
        this.svaeType = true
        this.$http
          .get("v1/learnonly/jf/singleBook", {
            params: { bookid: this.$route.query.bookid },
          })
          .then((res) => {
            console.log(res)
            if (res.data.data !== null) {
              this.modifyList = res.data
              this.coverFullUrl = res.data.book.coverFullUrl
              var colArr = []
              for (let k = 0; k < this.modifyList.book_image.length - 1; k++) {
                colArr.push(res.data.book_image[k].id)
              }
              var shareorgidArr = []
              shareorgidArr = res.data.shareorgids
            }
            this.formDate = {
              stageId: this.modifyList.book.stageId, //学段id
              subjectId: this.modifyList.book.subjectId, //学科id
              textbookVersionId: this.modifyList.book.textbookVersionId, //版本id
              gradeId: this.modifyList.book.gradeId, //年级id
              volumeid: this.modifyList.book.volumeid, //年级上下册
              orgId: this.modifyList.book.orgId, //组织id
              sharesorgids: shareorgidArr,
              name: this.modifyList.book.name, //教辅名称
              coverUrl: this.modifyList.book.coverUrl,
              describes: this.modifyList.book.describes, //教辅描述
              collaborators: colArr, //协作人
              state: this.modifyList.book.state, //教辅状态
              publicState: this.modifyList.book.publicState, //公开状态
              id: this.modifyList.book.id,
            }
            this.getAllselect(1)
            this.getOrg()
          })
      } else {
        // 新建教辅
        this.svaeType = false
        this.formDate = {
          stageId: "", //学段当前选中项
          subjectId: "", //学科当前选中项
          textbookVersionId: "", //版本当前选中项
          gradeId: "", //年级当前选中项
          volumeid: "", //年级上下册
          setorgid: this.$store.getters.orgid, //组织机构
          sharesorgids: [], //共享组织学校
          name: "", //教辅名称
          coverUrl: "",
          describes: "", //教辅描述
          collaborators: [],
          state: 0, //教辅状态
          publicState: this.$store.getters.roles.includes('admin') ? 0 : 1, //目标校本
          createuserId: this.$store.getters.id, //操作人id
        }
        this.getAllselect()
        this.getOrg()
      }
    },
    // 学段联动接口
    getAllselect (value) {
      this.$http
        .get("v1/learnonly/teachingAssistant/showVerGreSubSta", {
          params: {
            userid: this.$store.getters.id,
            stageid: this.formDate.stageId,
            subjectid: this.formDate.subjectId,
          },
        })
        .then((res) => {
          this.stagesList = res.data.stage
          this.subjectsList = res.data.subject
          this.versionsList = res.data.versions
          this.gradesList = res.data.grade
          if (this.$route.query.type == true) {
            if (value == 1) {
              setTimeout(() => {
                if (this.modifyList.book.stageId && this.stagesList) {
                  for (let [k, i] of Object.entries(this.stagesList)) {
                    if (k == this.modifyList.book.stageId) {
                      this.modelForm.stageName = k
                    }
                  }
                }
                if (this.subjectsList && this.modifyList.book.subjectId) {
                  for (let [k, i] of Object.entries(this.subjectsList)) {
                    if (k == this.modifyList.book.subjectId) {
                      this.modelForm.subjectName = k
                    }
                  }
                }
                if (
                  this.versionsList &&
                  this.modifyList.book.textbookVersionId
                ) {
                  for (let [k, i] of Object.entries(this.versionsList)) {
                    if (k == this.modifyList.book.textbookVersionId) {
                      this.modelForm.versionName = k
                    }
                  }
                }
                if (this.gradesList && this.modifyList.book.gradeId) {
                  for (let [k, i] of Object.entries(this.gradesList)) {
                    if (k == this.modifyList.book.gradeId) {
                      this.modelForm.gradeName = k
                    }
                  }
                }
              }, 500)
            }
          }
        })
    },
    changeStages (index) {
      this.formDate.stageId = index
      this.modelForm.subjectName = ""
      this.formDate.subjectId = ""
      this.modelForm.versionName = ""
      this.formDate.textbookVersionId = ""
      this.modelForm.gradeName = ""
      this.formDate.gradeId = ""
      this.getAllselect()
    },
    changeSubjects (event) {
      this.formDate.subjectId = event
      this.modelForm.versionName = ""
      this.formDate.textbookVersionId = ""
      this.getAllselect()
    },
    changeVersions (event) {
      this.formDate.textbookVersionId = event
    },
    changeGrades (event) {
      this.formDate.gradeId = event
    },
    changeVolume (event) {
      this.formDate.volumeid = event
    },
    // 组织机构
    getOrg () {
      this.$http
        .get("v1/learnonly/teachingAssistant/getOrgMessage")
        .then((res) => {
          if (res.data) {
            this.orgList = res.data.data
            if (this.$route.query.type == true) {
              for (let i = 0; i < this.orgList.length; i++) {
                if (this.orgList[i].id == this.modifyList.book.orgId) {
                  this.modelForm.orgName = this.orgList[i].id
                }
              }
            }
          }
        })
    },
    changeOrg (value) {
      if (this.$route.query.type == true) {
        if (value == undefined) {
          this.formDate.orgId = this.$store.getters.orgid
        } else {
          this.formDate.orgId = value
        }
      } else {
        if (value == undefined) {
          this.formDate.setorgid = this.$store.getters.orgid
        } else {
          this.formDate.setorgid = value
        }
      }
    },
    // 共享组织学校
    changeSharesorg (value) {
      this.formDate.sharesorgids = value
    },
    // 上传封面图片
    handleChange (info) {
      if (info.file.status === "uploading") {
        this.loading = true
        return
      }
      if (info.file.status === "done") {
        getBase64(info.file.originFileObj, (imageUrl) => {
          this.imageUrl = imageUrl
          this.loading = false
          this.uploadFormData = {
            cover: this.imageUrl,
          }
        })
        this.formDate.coverUrl = info.file.response
      }
    },
    // 协作人列表
    getCollaborators () {
      if (this.$store.getters.orgid != 0) {
        this.$http
          .get("v1/learnonly/jf/collas", {
            params: {
              orgid: this.$store.getters.orgid, //组织id
              // fullname: `${value}` //名称(模糊查询)
            },
          })
          .then((res) => {
            // 删除第一个登录人（登录人）本身
            this.collaboratorsList = res.data.slice(1)
          })
      }
    },
    // 选择协作人
    handleSearch (value) {
      this.formDate.collaborators = value
    },
    // 教辅状态
    getTeachState (event) {
      this.formDate.state = event.target.value
    },
    //目标公开状态
    getPublicState (event) {
      this.formDate.publicState = event.target.value
    },
    // 创建教辅书
    createList () {
      if (this.formDate.stageId == "") {
        this.$message.error("请选择学段")
        return
      }
      if (this.formDate.subjectId == "") {
        this.$message.error("请选择学科")
        return
      }
      if (this.formDate.name == "") {
        this.$message.error("请填写教辅名称")
        return
      }
      if (this.formDate.coverUrl == "") {
        this.$message.error("请上传图片")
        return
      }
      if (this.formDate.describes == "") {
        this.$message.error("请填写教辅描述")
        return
      }
      this.$http.post("v1/learnonly/jf/book", this.formDate).then((res) => {
        if (res.data.code == 200) {
          this.$message.success("创建教辅成功")
          setTimeout(() => {
            this.$router.push({
              path: "/library/addContent",
              query: {
                bankid: res.data.bankid,
                bookid: res.data.bookid, //
                bookName: res.data.bookName,
              },
            })
          }, 1000)
        } else {
          this.$message.warning("创建教辅失败")
        }
      })
    },
    // 修改教辅书
    getModifyList () {
      if (this.formDate.name == "") {
        this.$message.error("请填写教辅名称")
        return
      }
      if (this.formDate.coverUrl == "") {
        this.$message.error("请上传图片")
        return
      }
      if (this.formDate.describes == "") {
        this.$message.error("请填写教辅描述")
        return
      }
      this.$http.put("v1/learnonly/jf/book", this.formDate).then((res) => {
        if (res.data == true) {
          this.$message.success("修改教辅成功")
          setTimeout(() => {
            this.$router.push({
              path: "/library/assistant",
            })
          }, 1000)
        } else {
          this.$message.warning("修改教辅失败")
        }
      })
    },
    // 删除教辅书
    deleteBook () {
      this.$confirm({
        title: "确认删除该教辅吗？",
        okText: "确认",
        cancelText: "取消",
        onOk: () => {
          this.$http
            .delete("v1/learnonly/jf/book", {
              params: {
                userid: this.$store.getters.id,
                bookid: this.$route.query.bookid,
              },
            })
            .then((res) => {
              if (res.status == 200) {
                if (res.data == true) {
                  this.$message.success("删除成功")
                  setTimeout(() => {
                    this.$router.push({
                      path: "/library/assistant",
                    })
                  }, 1000)
                } else {
                  this.$message.error("删除失败")
                }
              }
            })
        },
        onCancel: () => {
          this.$message.info("已取消")
        },
      })
    },
    goBack () {
      window.history.go(-1)
    },
  },
  mounted () {
    this.getModifyData()
    this.getAllselect()
    this.getCollaborators()
  },
}
</script>

<style scoped>
.addBook {
  padding: 25px;
}
#add .dropbox {
  height: 180px;
  line-height: 1.5;
}
/deep/.ant-form-item {
  margin-bottom: 12px;
}
</style>
